import { render, staticRenderFns } from "./detailPure_address_m.vue?vue&type=template&id=3ecae966"
import script from "./detailPure_address_m.vue?vue&type=script&lang=js"
export * from "./detailPure_address_m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports